import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { DateUtil } from '../../ui/DateUtil';

@Component({
  selector: 'app-form-date-field',
  templateUrl: './form-date-field.component.html',
  styleUrl: './form-date-field.component.scss'
})
export class FormDateFieldComponent extends FieldType {
  value = "";
  ngOnInit(): void {
    this.value = DateUtil.getDate(this.formControl.value);
  }
}
